define('collections/conversation/messages',[
    'underscore',
    'backbone',
    'utils',
    // super class
    'src/plugins/infinite-collection',
    // models
    'models/conversation/message'
], function(
    _, Backbone, U,
    // super class
    InfiniteCollection,
    // models
    MMessage
) {
    var imagesExtensions = ['jpg', 'png', 'bmp', 'tiff', 'jpeg'];

    var CMessages = InfiniteCollection.extend({
        model: MMessage,
        state: {
            pageSize: 5,
            sortKey: 'date',
            order: 1,
        },

        // sort by date as UTC string (reverse chronological order)
        comparator: function(a, b) {
            return a.get('date').localeCompare(b.get('date'));
        },

        initialize: function(models, opt) {
            opt = opt || {};
            if (opt.user) this.user = opt.user;
            if (opt.group) this.group = opt.group;
            if (opt.conversation) this.conversation = opt.conversation;
            if (opt.users) this.users = opt.users;

            this.listenTo(this, 'update reset', this.onCollectionUpdate);

            CMessages.__super__.initialize.call(this, [models, opt]);
        },

        setAttachmentsIcon: function() {
            var typeFile = "",
                isPicture = false;

            this.each(function(message) {
                var attachments = message.get('attachments');
                if (!attachments) return;

                _.each(attachments, function(attachment) {
                    if (attachment && attachment.name) {
                        typeFile = attachment.name.split('.').pop().toLowerCase();
                        isPicture = attachment.isPicture = imagesExtensions.indexOf(typeFile) > -1;
                        attachment.icon = isPicture ? 'sl-icon-picture' : 'sl-icon-paper-clip';
                    }
                }, this);
            }, this);

            return this;
        },

        setAttachmentsUrl: function() {

            this.each(function(message) {
                var attachments = message.get('attachments');
                if (!attachments) return;

                _.each(attachments, function(attachment) {
                    if (attachment) {
                        attachment.url = attachment.file;
                    }
                }, this);
            }, this);

            return this;
        },

        setUserPicture: function() {
            var users = this.users,
                picture;

            this.each(function(message) {
                var user = users[message.get('user')];
                if (!user) return;
                message.set('userPicture', user.picture.thumbnail);
            }, this);

            return this;
        },

        setDisplayName: function() {
            var users = this.users;

            this.each(function(message) {
                var user = users[message.get('user')];
                if (!user) return;
                message.set('displayName', user.displayName);
            }, this);

            return this;
        },

        setUsers: function(users) {
            this.users = users;
            return this;
        },

        prepareCollection: function() {
            this.setAttachmentsIcon()
                .setAttachmentsUrl()
                .setUserPicture()
                .setDisplayName();
        },

        onCollectionUpdate: function() {
            this.prepareCollection();
        },

    });

    return CMessages;
});

